import _ from 'lodash';
import React from 'react';
import { Alert, Container, Row, Col } from 'reactstrap';
import { FitText, PropTypes, IdleProgress } from '~/utils';
import { log } from '@swiper/core';

export function ErrorBox( props ) {
  log.error( props.title, props.error );
  return (
    <Container fluid className="h-100 error-box text-center">
      <Row className="h-100">
        <Col className="my-auto">
          <Alert color={props.color}>
            <FitText>{ props.title || 'ERROR' }</FitText>
            <FitText>{ props.error.message || props.error }</FitText>
          </Alert>
        </Col>
      </Row>
      <IdleProgress />
    </Container>
  );
}
ErrorBox.propTypes = {
  title : PropTypes.string,
  error : PropTypes.oneOfType( [
    PropTypes.string,
    PropTypes.instanceOf( Error ),
  ] ).isRequired,
  color : PropTypes.oneOf( [ 'success', 'info', 'warning', 'danger' ] ),
};
ErrorBox.defaultProps = {
  color : 'danger',
};
